module.exports = __webpack_public_path__ + "img/cement.1eb279b9.png";